import { render } from "./AddInsuranceModal.vue?vue&type=template&id=2994794c&scoped=true&ts=true"
import script from "./AddInsuranceModal.vue?vue&type=script&lang=ts"
export * from "./AddInsuranceModal.vue?vue&type=script&lang=ts"

import "./AddInsuranceModal.vue?vue&type=style&index=0&id=2994794c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2994794c"]])

export default __exports__